import { create } from 'zustand';

// What the "Take photo" popup checked in this run, kept while the run page is open, so opening the popup
// again shows the earlier photos and what they marked (and lets the person add more).
// Photos are in-memory blobs: a page reload starts a new session (Analytics still has every photo).
export interface RunPhotoSession {
  checked: any[];
  decidedBy: { [taskId: string]: number };
  outOfPhoto: string[];
  response?: any;
}

interface RunPhotoSessionState {
  sessions: { [runKey: string]: RunPhotoSession };
  save: (runKey: string, session: RunPhotoSession) => void;
  clear: (runKey: string) => void;
}

export const useRunPhotoSessionStore = create<RunPhotoSessionState>(set => ({
  sessions: {},
  save: (runKey, session) =>
    set(state => ({ sessions: { ...state.sessions, [runKey]: session } })),
  clear: runKey =>
    set(state => {
      const sessions = { ...state.sessions };
      delete sessions[runKey];
      return { sessions };
    })
}));
